import { handlePaginatedData } from '../services/DataHelperFunctions';
import { EAction, EApiType, EUrlParams } from '../data/Constants';
import AxiosClient from './AxiosClient';
import { handleSuccess, handleApiErrorWithFallback, handleError } from './HttpUtil';
import type { Dispatch } from '@reduxjs/toolkit';

export const UserApi = {
  getUsers: (action: { page: number; limit: number; searchCode?: string }, dispatch: Dispatch) => {
    const queryParams = new URLSearchParams({
      [EUrlParams.Page]: String(action.page),
      [EUrlParams.Limit]: String(action.limit),
    });
    if (action.searchCode) {
      queryParams.set(EUrlParams.Search, action.searchCode);
    }
    return AxiosClient.post(`/user/v1/read?${queryParams}`, [])
      .then((response) => {
        return handlePaginatedData(response, action);
      })
      .catch((err) => {
        return handleApiErrorWithFallback(
          dispatch,
          err,
          { page: action.page, searchKey: action.searchCode },
          EAction.Read,
          EApiType.UserKey
        );
      });
  },

  createUser: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/user/v1/role/create', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Create);
      });
  },

  updateUser: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/user/v1/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  updateUserRoleAssociation: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/role/v1/user/association/update', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Update);
      });
  },

  deleteUsers: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/user/v1/delete', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },

  exportUserDetails: (dispatch: Dispatch) => {
    return AxiosClient.get('/user/v1/info/export', { responseType: 'arraybuffer' })
      .then((response) => {
        return handleSuccess(response, EAction.Download);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Download);
      });
  },

  getUserDetails: (action: { request }, dispatch: Dispatch) => {
    return AxiosClient.post('/user/v1/read', action.request)
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err, EAction.Get);
      });
  },

  getLoggedInUserDetails: (dispatch: Dispatch) => {
    return AxiosClient.get('/user/v1/details')
      .then((response) => {
        return handleSuccess(response);
      })
      .catch((err) => {
        return handleError(dispatch, err);
      });
  },
};
